/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/match_operator.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Use the match operator (`:`) to perform a match query on the specified field or expression.\nUsing `:` is equivalent to using the `match` query in the Elasticsearch Query DSL.\n\nThe match operator is equivalent to the match function.\n\nFor using the function syntax, or adding match query parameters, you can use the\nmatch function.\n\n`:` returns true if the provided query matches the row.',
  examples: [
    'FROM books\n| WHERE author:"Faulkner"',
    'FROM employees\n| WHERE job_positions:"Internship"\n| KEEP emp_no, job_positions',
    'FROM books METADATA _score\n| WHERE semantic_title:"Shakespeare"\n| SORT _score DESC\n| KEEP _score, semantic_title',
  ],
  params: {
    field: 'Field or expression that the query will target.',
    query: 'Value to find in the provided field or expression.',
  },
};

export default docs;
